import React, { useEffect, useRef, useState } from "react";
// import { getResults } from '../../services/results/resultsService';
import { deleteFinalResultsFiles } from "../../../../../../services/olympiad/resultsFilesService";
import { Button } from "../../../../../../components/forms/Buttons/Button";
import CustomDialog from "../../../../../../components/modals/CustomDialog/CustomDialog";
import Select from "../../../../../../components/forms/Select/Select";
import { ArrowUpTrayIcon, TrashIcon } from "@heroicons/react/24/outline";
// import useSnackbar from "../../../../../../utils/hooks/useSnackbar";

export default function DELETE({ file, onDelete }) {
  // const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [resultsFiles, setResultsFiles] = useState([]);
  // const { addSnackbar } = useSnackbar();

  return (
    <>
      <TrashIcon
        className={`h-7 cursor-pointer rounded-lg border border-error p-1 text-error ${
          !isLoading && "hover:bg-error hover:text-red-100"
        }`}
        onClick={() => {
          const isConfirmed = window.confirm(
            "Are you sure want't to delete this file?"
          );
          console.log(isConfirmed);
          if (!isConfirmed) return;
          deleteFinalResultsFiles(file.uuid)
            .then((res) => {
              if (onDelete) onDelete();
            })
            .finally(() => setIsLoading(false));
          // alert.apply()
        }}
      />
      {/* <CustomDialog
        isOpen={open}
        closeModal={() => {
          setOpen(false);
        }}
      >
        <Button
          Icon={ArrowUpTrayIcon}
          color='primary'
          className='h-9'
          text='Файлды жіберу'
          loading={loading}
          onClick={() => {
            if (isAsp !== null && leg !== null && file) {
              setLoading(true);
              const body = new FormData();
              body.append('file', file);
              body.append('round', leg);
              body.append('is_asp', isAsp);

              postFinalResultsFiles(body)
                .then((res) => {
                  setUploads(res?.comments);
                  setCount(res.comments.length);
                  setFileError(res?.has_errors);
                  setFileStatus(res?.file_status);
                })
                // .catch(() => {
                //   addSnackbar(t('Ошибка'), 'error');
                // })
                .finally(() => {
                  setLoading(false);
                  setFile(null);
                  inputRef.current.value = null;
                  setLeg(null);
                  setIsAsp(null);
                });
            }
            if (file === null) {
              addSnackbar('Файлды таңдаңыз', 'error');
            } else if (isAsp === null || leg === null) {
              addSnackbar('Турды / ӘОТ таңдаңыз', 'error');
            }
          }}
        />
      </CustomDialog> */}
    </>
  );
}
